import { InjectionToken } from '@angular/core';

/**
 * Configuração de tema/visual do módulo de autenticação
 */
export interface AuthThemeConfig {
  /** URL do logo exibido nas telas de autenticação */
  logoUrl: string;
  /** URL do site da aplicação (link no logo) */
  siteUrl: string;
  /** Nome da aplicação */
  appName: string;
}

/**
 * Configuração de funcionalidades do módulo de autenticação
 */
export interface AuthFeaturesConfig {
  /** Habilita/desabilita a funcionalidade de cadastro (registro) */
  enableRegistration: boolean;
  /** Habilita/desabilita a funcionalidade de reset de senha */
  enablePasswordReset: boolean;
}

/**
 * Configuração de rotas do módulo de autenticação
 */
export interface AuthRoutesConfig {
  /** Rota para login (padrão: 'login') */
  loginRoute?: string;
  /** Rota para solicitar reset de senha (padrão: 'solicitar-reset-senha') */
  requestPasswordResetRoute?: string;
  /** Rota para confirmar reset de senha (padrão: 'reset-senha') */
  confirmPasswordResetRoute?: string;
  /** Rota para cadastro/registro (padrão: 'novo-cadastro') */
  registrationRoute?: string;
  /** Rota de redirecionamento após login bem-sucedido (padrão: '/dashboard') */
  redirectAfterLogin?: string;
}

/**
 * Configuração completa do módulo de autenticação
 */
export interface AuthModuleConfig {
  /** Configuração de tema/visual */
  theme: AuthThemeConfig;
  /** Configuração de funcionalidades */
  features: AuthFeaturesConfig;
  /** Configuração de rotas */
  routes?: AuthRoutesConfig;
}

/**
 * Token de injeção para configuração do módulo de autenticação
 */
export const AUTH_CONFIG = new InjectionToken<AuthModuleConfig>('AUTH_CONFIG');

/**
 * Configuração padrão do módulo
 */
export const DEFAULT_AUTH_CONFIG: Partial<AuthModuleConfig> = {
  routes: {
    loginRoute: 'login',
    requestPasswordResetRoute: 'solicitar-reset-senha',
    confirmPasswordResetRoute: 'reset-senha',
    registrationRoute: 'novo-cadastro',
    redirectAfterLogin: '/dashboard',
  },
  features: {
    enableRegistration: true,
    enablePasswordReset: true,
  },
};
